import { css } from 'styled-components';

import { mediaHover } from 'themes/mixins/mediaHover';
import { pickColor } from 'themes/helpers/pickColor';

const motives = {
  m1: css`
    border-collapse: collapse;

    border: 0.1rem solid ${pickColor('tableGray')};

    font-size: 1.2rem;

    thead {
      background-color: ${pickColor('tableGray')};
      color: ${pickColor('black')};
      tr {
        border-bottom: 0.1rem solid ${pickColor('tableGray')};
      }
      th {
        height: 4.8rem;
        padding: 1rem 1.5rem;
      }
    }

    tbody {
      background-color: ${pickColor('white')};

      tr {
        transition: background-color ${({ theme }) => theme.transitionSpeed} ease-in;

        ${mediaHover(css`
          background-color: ${pickColor('tableRow')};
        `)}
      }
    }

    td {
      border-bottom: 0.1rem solid ${pickColor('tableGray')};

      font-weight: 500;

      padding: 0rem 1.5rem;
      height: 4.8rem;
    }
  `,
  m2: css`
    border: 0.1rem solid ${pickColor('borderColorDark')};
    border-radius: ${({ theme }) => theme.borderRadius.base};

    th {
      border-bottom: 0.1rem solid ${pickColor('borderColorDark')};
    }
  `,
  m3: css`
    border-collapse: collapse;
    border: 0.1rem solid ${pickColor('borderColorDarkSecondary')};

    font-size: 1.2rem;

    thead {
      background-color: ${pickColor('borderColorDarkSecondary')};
      color: ${pickColor('white')};

      tr {
        border-bottom: 0.1rem solid ${pickColor('borderColorDarkSecondary')};
      }

      th {
        height: 4.8rem;
        padding: 1rem 1.5rem;
      }
    }

    tbody {
      background-color: ${pickColor('white')};

      tr {
        transition: background-color ${({ theme }) => theme.transitionSpeed} ease-in;

        ${mediaHover(css`
          background-color: ${pickColor('tableRow')};
        `)}
      }
    }

    td {
      padding: 0rem 1.5rem;
      height: 4.8rem;
      border-bottom: 0.1rem solid ${pickColor('borderColorDarkSecondary')};

      font-weight: 500;
    }
  `,
};

export type TableMotives = keyof typeof motives;

const pickMotive = (motive: TableMotives) => motives[motive];

export { pickMotive };
